import {animate, state, style, transition, trigger} from '@angular/animations';
import {Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";

//LZ import {DialogComponent} from "../../../../../projects/ZZZ/components/dialog/dialog.component";
import {DialogComponent} from "libComm";
import {MatDialog} from "@angular/material/dialog";
import {TranslateService} from '@ngx-translate/core';
import {CoreService} from "libComm";

//QQQ
import {NavItem} from "libComm";
import {NavService} from "libComm";


@Component({
	selector: "app-menu-list-item",
	templateUrl: "./menu-list-item.component.html",
	styleUrls: ["./menu-list-item.component.scss"],
	animations: [
		trigger("indicatorRotate", [
			state("collapsed", style({transform: "rotate(0deg)"})),
			state("expanded", style({transform: "rotate(180deg)"})),
			transition(
				"expanded <=> collapsed",
				animate("225ms cubic-bezier(0.4,0.0,0.2,1)")
			)
		])
	]
})
export class MenuListItemComponent implements OnInit
{
	expanded: boolean = false;

	@HostBinding("attr.aria-expanded") ariaExpanded = this.expanded;
	@Input() item!: NavItem;

	@Input() depth!: number;

	selected: boolean = false;

	private translateService: TranslateService;

	constructor(
		public navService: NavService,
		public router: Router,
		public dialog: MatDialog,
		private activatedRoute: ActivatedRoute,
		// private translateService: TranslateService,
		private coreService: CoreService
	)
	{
		this.translateService = coreService.getTranslatorService();

		if (this.depth === undefined)
		{
			this.depth = 0;
		}
	}

	ngOnInit(): void
	{
	}

	// event handler called when user click on a menu item
	onItemSelected(item: NavItem)
	{
		//(item)
		if ( !item.children ||
			 !item.children.length ||
			 item.children.length <= 1 )
		{
			sessionStorage.setItem("path", item.pageId ?? "$EMPTY$");

			this.navService.selectedItem = item;

			//localStorage.setItem('lastUrl', item.route)
			let selectedItm = item;

			if (item.children?.length == 1)
			{
				selectedItm = item.children[0];
			}

			if ( !!localStorage.getItem("changes") &&
				  localStorage.getItem("changes") == "true"	)
			{
				const dialogRef = this.dialog.open(DialogComponent, {
					data: {
						title: "Unsaved changes",
						content: `If you leave this page the creations or changes you have made so far will not be saved. How would you like to proceed?`,
						cancelButtonLabel: "Stay",
						cancelButtonColor: "basic",
						confirmButtonLabel: "Leave",
						confirmButtonColor: "accent"
					}
				});

				dialogRef.afterClosed().subscribe((res) =>
				{
					if (res && res == true)
					{
						this.router.navigate([selectedItm.route], {
							queryParams: {
								id: selectedItm.pageId,
								title: this.translateService.instant(
									selectedItm.displayName
								)
							}
						});
					}
				});
			}
			else
			{
				this.router.navigate([selectedItm.route], {
					queryParams: {
						id: selectedItm.pageId,
						title: this.translateService.instant(
							selectedItm.displayName
						)
					}
				});
			}

			this.navService.closeNav();
		}

		if (item.children && item.children.length)
		{
			this.expanded = !this.expanded;
		}
	}

	isSelected(item: NavItem): boolean
	{
		const sessionPageId = sessionStorage.getItem("path");
		/*if{
        }
        return !!(item.route && window.location.pathname.includes(item.route))*/

		console.log(sessionPageId);
		console.log(item);

		return !!(
			sessionPageId &&
			sessionPageId != "$EMPTY$" &&
			sessionPageId == item.pageId
		);
	}

	getBadgeValue(item: NavItem): number
	{
		let sum: number = 0;

		if (item.badge !== undefined && item.badge !== null)
		{
			sum += item.badge;
		}

		// Se l'item ha figli, verifica ricorsivamente
		// if item has any child then check recursively
		if (item.children && item.children.length > 0)
		{
			for (const child of item.children)
			{
				const badgeValue = this.getBadgeValue(child);

				if (badgeValue)
				{
					sum += badgeValue;
				}
			}
		}

		return sum;
	}
}
